<template>
  <v-btn
    v-bind="$attrs"
    v-on="$listeners"
    :disabled="disabled"
    fab
    depressed
    :class="['button']"
    :style="{
      backgroundColor: disabled ? '#ACABAB !important' : undefined,
      color: disabled ? '#fff !important' : undefined,
    }">
    <slot></slot>
  </v-btn>
</template>

<script>

export default {
  name: 'ButtonHeader',
  props: {
    disabled: {
      default: false,
      type: Boolean
    }
  }
}

</script>

<style lang="scss" scoped>
  .button {
    height: 20px;
    width: 20px;
    min-width: 20px;
    margin-left: 4px;
    background-color: #0F6FFF !important;
    color: #fff;
  }
</style>
